export const abCampaingnEvent = ({ testName, variationId }) => ({
  type: 'Flagship Test',
  data: {
    'Test Name': testName,
    VariationID: variationId,
  },
});
